/* if adding a new flag, update use-record-all-flags.ts */

"use client";

import { usePostHogFlag } from "../use-posthog-flag";

export function useSepaAccountsEnabled() {
  return usePostHogFlag("enable_sepa_accounts");
}
